import * as React from 'react';
import { useState } from 'react';
import { AbsenceItemType } from '../types';
import StatusIcon from '../../../../../../atomic/atoms/StatusIcon/StatusIcon';
import FlairDateRange from '../../../../../../atomic/molecules/DateRange/FlairDateRange';
import CommentsPopover from '../../../../components/Comment/CommentsPopover';
import { RelatedObjectNames } from '../../../../components/Comment/types';
import AbsenceCategoryIcon from '../../../../components/AbsenceCategoryIcon';
import AbsenceAmount from '../../../Absences/components/AbsenceAmount';
import FlairIcon from '../../../../../../atomic/atoms/FlairIcon';
import MultiDayAbsenceBtn from '../../../Absences/components/MultiDayAbsenceDetails/MultiDayAbsenceBtn';
import MultiDayAbsenceDetails from '../../../Absences/components/MultiDayAbsenceDetails';
import './AbsenceItem.css';
import { FlairDateFormat } from '../../../../../../atomic/atoms/FlairFormattedDate/types';
import { isMultiDayAndHourly } from '../../../../pages/Absences/components/MultiDayAbsenceDetails/logic';

type Props = {
  absence: AbsenceItemType;
};

const AbsenceItem: React.FC<Props> = ({ absence }) => {
  const [selectedAbsenceId, setSelectedAbsenceId] = useState<string>('');

  const {
    status,
    categoryIcon,
    categoryName,
    startDateTime,
    endDateTime,
    id,
    commentsCount,
  } = absence;

  const handleCloseSidebar = () => {
    setSelectedAbsenceId('');
  };

  return (
    <>
      <div className="absence-item d-flex gap-3-5">
        <StatusIcon status={status} />
        <div className="d-flex flex-column gap-1">
          <div>
            <AbsenceCategoryIcon icon={categoryIcon} />
            <span className="ms-2-5">{categoryName}</span>
            <FlairIcon
              icon="ellipse-filled"
              size="xxxs"
              className="mx-3 mb-1"
            />
            <div className="d-inline-flex align-items-center">
              <AbsenceAmount
                type={absence.type}
                amount={absence.withdrawalAmount}
                variant="work"
              />
              {isMultiDayAndHourly(absence) && (
                <>
                  <FlairIcon
                    icon="ellipse-filled"
                    size="xxxs"
                    className="mx-3 mb-1"
                  />
                  <MultiDayAbsenceBtn
                    absenceId={id}
                    onClick={setSelectedAbsenceId}
                  />
                </>
              )}
            </div>
          </div>

          <FlairDateRange
            className="h4-regular absence-date-range-container"
            dateFrom={startDateTime}
            dateTo={endDateTime}
            format={FlairDateFormat.WeekdayShortMonthDayYear}
          />

          <CommentsPopover
            recordId={id}
            relatedObjectName={RelatedObjectNames.Absence}
            commentsCount={commentsCount}
            mode="text"
          />
        </div>
      </div>
      {selectedAbsenceId && (
        <MultiDayAbsenceDetails
          absenceId={selectedAbsenceId}
          show={true}
          onClose={handleCloseSidebar}
        />
      )}
    </>
  );
};

export default AbsenceItem;
